import { IdentityDocumentTypeEnum } from '../../../shared/enums/identity-document-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { CustomerStatusEnum } from '../enums/customer-status.enum';
import { CustomerTypeEnum } from '../enums/customer-type.enum';

/**
 * Customer DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.CUSTOMER)
export class CustomerSearchDto extends BaseSearchDto {
  code!: string;
  type!: CustomerTypeEnum;
  status!: CustomerStatusEnum;
  contactShortName?: string | null;
  driverId?: number | null;
  driverIdentityDocumentType?: IdentityDocumentTypeEnum | null;
  driverIdentityDocumentNumber?: string | null;
  driverIdentityDocumentExpiryDate?: Date | null;
  driverDrivingLicenseNumber?: string | null;
  driverDrivingLicenseCategory?: string | null;
  driverDrivingLicenseExpiryDate?: Date | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
